import { PayloadAction } from '@reduxjs/toolkit';
import { all, fork, put, call, takeLatest, select } from 'redux-saga/effects';
import { getRequest, listRequest } from '../../services/admin';
import { IUpdateState, updateState } from 'core/actions/product/state';
import { EntityTypes } from 'constants/entities';

import { RootState } from 'types';
import { Role } from 'types/domain/role';

function* updateStateSaga(action: PayloadAction<IUpdateState>) {
  const role: Role = yield select((state: RootState) => state.session.role);

  if (role > Role.LEARNER && action.payload.type === EntityTypes.MODULE)
    yield put(
      listRequest({
        type: EntityTypes.FORUM_TOPIC,
        parentEntityType: EntityTypes.MODULE,
        parentEntityId: action.payload.id,
        pagerInfo: { page: 0 },
      }),
    );
}

function* getFulFilledSaga(action) {
  if ([EntityTypes.MODULE, EntityTypes.COURSE, EntityTypes.STRUCTURE].includes(action.meta.arg.type))
    if (action.payload.forumId)
      yield put(yield call(updateState, { type: EntityTypes.FORUM_TOPIC, id: action.payload.forumId }));
}

function* watchState() {
  yield takeLatest(updateState.type, updateStateSaga);
}

function* watchGetFulfilled() {
  yield takeLatest(getRequest.fulfilled, getFulFilledSaga);
}

export function* forumSaga() {
  yield all([fork(watchState), fork(watchGetFulfilled)]);
}
